import React from "react";

const FundManagers = () => {
  // Data for team members
  const members = [
    { name: "NAME NAME", designation: "DESIGNATION" },
    { name: "NAME NAME", designation: "DESIGNATION" },
    { name: "NAME NAME", designation: "DESIGNATION" },
    { name: "NAME NAME", designation: "DESIGNATION" },
  ];

  return (
    <div className="max-w-5xl ">
      <h2 className="text-2xl font-bold text-[#0D215C] mb-12">
        Portfolio Managers and working team
      </h2>

      <div className="grid grid-cols-2  gap-8 ml-8">
        {members.map((member, index) => (
          <div key={index} className="flex items-center space-x-4 p-4">
            {/* Circular avatar */}
            <div className="w-16 h-16 bg-gray-200 border-2 border-gray-500 rounded-full"></div>

            {/* Name and Designation */}
            <div>
              <h3 className="font-bold text-gray-700">{member.name}</h3>
              <p className="font-bold text-gray-900">{member.designation}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FundManagers;
